<div class="header-wrapper">
    <h2 class="title">Add Time Off</h2>
    <div class="member-wrapper">{{addTimeOffDetails?.firstName}} {{addTimeOffDetails?.lastName}}</div>
</div>
<form [formGroup]="timeOffForm">
    <div class="form-field ui-g-12 ui-md-6 ui-lg-6">
        <div class="form-label">
            <label translate>Start Date</label>
            <label class="asterisk">*</label>
        </div>
        <div class="form-control-c">
            <p-calendar formControlName="startDate" [showIcon]="true"  (onSelect)="changeDate($event)"
                [dateFormat]="dateFormat" [placeholder]="'Start Date'" [minDate]="minDate">
            </p-calendar>
        </div>
        <div class="form-errors"
            *ngIf="timeOffForm.controls.startDate.errors  && (timeOffForm.controls.date.dirty || timeOffForm.controls.startDate.touched)">
            <div [hidden]="!timeOffForm.controls.startDate.errors.required" translate>
                Start Date is required
            </div>
        </div>
    </div>
    <div class="form-field ui-g-12 ui-md-6 ui-lg-6">
        <div class="form-label">
            <label translate>End Date</label>
            <label class="asterisk">*</label>
        </div>
        <div class="form-control-c">
            <p-calendar formControlName="endDate" [showIcon]="true"  (onSelect)="changeEndDate($event)"
                [dateFormat]="dateFormat" [defaultDate]="minEndDate" [placeholder]="'End Date'" [minDate]="minEndDate" [maxDate]="maxEndDate">
            </p-calendar>
        </div>
        <div class="form-errors"
            *ngIf="timeOffForm.controls.endDate.errors  && (timeOffForm.controls.endDate.dirty || timeOffForm.controls.endDate.touched)">
            <div [hidden]="!timeOffForm.controls.endDate.errors.required" translate>
                End Date is required
            </div>
        </div>
    </div>

    <div class="form-field ui-g-12 ui-md-6 ui-lg-6">
        <div class="form-label">
            <label for="" translate>Leave Type</label>
            <label class="asterisk">*</label>
        </div>
        <div class="form-control-c">
            <p-dropdown autocomplete="off" [options]="leaveTypeList" [style]="{'width': '100%'}" filter="filter"
                [resetFilterOnHide]="true" formControlName="leaveTypeId" [style]="{'width': '100%'}">
            </p-dropdown>
        </div>
    </div>
    <div class="form-field ui-g-12 ui-md-6 ui-lg-6">
        <div class="form-label">
            <label for="" translate></label>
            <!-- <label class="asterisk">*</label> -->
        </div>
    <div class="form-control-c mt-10">
        <label translate>Time Off</label>
        <label class="asterisk">*</label>
        <span class="right-wrapper">
            <p-inputSwitch formControlName="fullDayOff" styleClass="input-switcher" (onChange)="enableFullDayLeave($event.checked)"></p-inputSwitch>
            <label class="pl-5" translate>24h</label>
        </span>
    </div>
</div>

    <div class="ui-g-12 p-0">
    <div class="form-field ui-g-12 ui-md-6 ui-lg-6">
        <div class="form-control-c">
            <p-calendar class="schedule-calender-timer" formControlName="startTimeStr" [showIcon]="true" hourFormat="12" (onBlur)="getTime($event)"
                [disabled]="isFullDayLeave" timeOnly="true" [stepMinute]="15" [placeholder]="'Start Time' | translate" icon="pi pi-clock" [defaultDate]="currentDate">
            </p-calendar>
        </div>
        <div class="form-errors"
            *ngIf="timeOffForm.controls.startTimeStr.errors  && (timeOffForm.controls.startTimeStr.dirty || timeOffForm.controls.startTimeStr.touched)">
            <div [hidden]="!timeOffForm.controls.startTimeStr.errors.required" translate>
                Start Time is required
            </div>
        </div>
    </div>
    <div class="form-field ui-g-12 ui-md-6 ui-lg-6">
        <!-- <div class="form-label">
            <label translate></label>
        </div> -->
        <div class="form-control-c">
            <p-calendar class="schedule-calender-timer" formControlName="endTimeStr" [showIcon]="true" hourFormat="12" (onBlur)="getEndTime($event)"
            [disabled]="isFullDayLeave" timeOnly="true" [stepMinute]="15" [placeholder]="'End Time' | translate" icon="pi pi-clock" [defaultDate]="currentDate">
            </p-calendar>
        </div>
        <div class="form-errors"
            *ngIf="timeOffForm.controls.endTimeStr.errors  && (timeOffForm.controls.endTimeStr.dirty || timeOffForm.controls.endTimeStr.touched)">
            <div [hidden]="!timeOffForm.controls.endTimeStr.errors.required" translate>
                End Time is required
            </div>
        </div>
    </div>
    </div>
    <div class="form-field ui-g-12 ui-md-12 ui-lg-12">
        <div class="form-label">
            <label translate>Notes</label>
        </div>
        <div class="form-control-c">
            <textarea [rows]="4" [cols]="30" maxlength="300" [placeholder]="'Enter Notes' | translate"
                formControlName="notes" class="no-resize"></textarea>
        </div>
    </div>

    <div class="form-buttons ui-g-12 ui-g-nopad pt-20">
        <button class="save-btn" pButton type="submit" [label]="'Save' | translate" [disabled]="!timeOffForm.valid || isDisableBtn"
            (click)="addTimeOff()"></button>
        <button class="cancel-btn" pButton type="button" [label]="'label_cancel' | translate"
            (click)="cancel()"></button>
    </div>
</form>